import { useAppSelector } from '../../../app/hooks';
import { useEffect, useState } from 'react';
import { AICA_CREATE_DEAL_DETAILS, CONFIG_STEP, USER_TYPE } from '../../ManageDealDrawer/DealDrawerConstants';
import { getDealFormConfig } from '../../../store/investor/apiHelpers';
import { PageType, StepperItem } from '../Components/Page/PageTypes';
import { useLocation, useSearchParams } from 'react-router-dom';
import { DEAL_VIEW_TYPES } from '../../../store/investor/constants';
import { isLenderType } from '../../../utils/utils';

const useFetchConfigForDrawer = (enabled: boolean) => {
    // Redux Selectors
    const source = useAppSelector((state) => state.investor.dealApplicationDrawer.source);
    const loggedInUser = useAppSelector((state) => state.user.userData);
    const platformData = useAppSelector((state) => state.user.domainMetadata);
    const userType = useAppSelector((state) => state.user.userData.accountType);
    const location = useLocation();

    // State Variables
    const [drawerConfig, setDrawerConfig] = useState<{
        pages: PageType[] | [];
        stepper: StepperItem[] | [];
        filters: any | [];
    }>({
        pages: [],
        stepper: [],
        filters: [],
    });
    const [loadingConfig, setLoadingConfig] = useState(false);
    const [params, setParams] = useSearchParams();
    const selectedCategory = params.get('category') || DEAL_VIEW_TYPES.DEAL_VIEW;

    // Fetch Config Name on the basis of source
    const fetchConfigName = () => {
        switch (source) {
            case 'debtProducts':
            case 'createDeal':
            case 'editDeal':
            case 'DEAL_FILTERS':
                return AICA_CREATE_DEAL_DETAILS;
            case 'STATUS_TIMELINE':
                return AICA_CREATE_DEAL_DETAILS;
            default:
                break;
        }
    };

    const fetchFilters = (configData) => {
        if (isLenderType(userType)) {
            return configData?.lenderFilters;
        }
        switch (selectedCategory) {
            case DEAL_VIEW_TYPES.MANDATE_VIEW:
                return configData?.mandateFilters;
            case DEAL_VIEW_TYPES.DEAL_VIEW:
                return configData?.dealViewFilters;
            default:
                return configData?.dealViewFilters;
        }
    };

    // Fetch Config
    const fetchConfig = async () => {
        const configName = fetchConfigName();
        switch (configName) {
            case AICA_CREATE_DEAL_DETAILS:
                await getDealFormConfig(
                    {
                        accountType: loggedInUser.accountType,
                        investorOrgId: platformData?.investorOrgId,
                        primaryEmail: loggedInUser?.primaryEmail,
                        configName: configName,
                    },
                    {
                        onSuccess: (configData, orgName) => {
                            let filters = fetchFilters(configData);
                            switch (source) {
                                case 'DEAL_FILTERS':
                                    setDrawerConfig({
                                        pages: [],
                                        stepper: [],
                                        filters: filters,
                                    });
                                    break;
                                default:
                                    // if (orgName) setInvestorName(orgName);
                                    let pages = configData?.pages ?? [];
                                    let stepper = configData?.stepper ?? [];

                                    if (
                                        configName === AICA_CREATE_DEAL_DETAILS &&
                                        (location.pathname.includes('deals') || location.pathname.includes('company-deals'))
                                    ) {
                                        pages = pages.filter((page: any) => page.step !== CONFIG_STEP.SELECT_INVESTORS);
                                        stepper = stepper.filter((item: any) => item.stepId !== CONFIG_STEP.SELECT_INVESTORS);
                                    }
                                    setDrawerConfig({
                                        pages: pages,
                                        stepper: stepper,
                                        filters: [],
                                    });
                                    // setStepperConfig(configData?.stepper ?? []);
                                    break;
                            }
                        },
                    },
                );
                break;
            default:
                break;
        }
    };

    // Effects

    useEffect(() => {
        if (!enabled) return;
        setLoadingConfig(true);
        fetchConfig().then(() => {
            setLoadingConfig(false);
        });
    }, [source]);

    return {
        drawerConfig,
        loadingConfig,
    };
};

export default useFetchConfigForDrawer;
